// 找最近的可滚动祖先，找不到就是 window
export const findScrollParent = (el) => {
  let node = el?.parentElement;
  while (node && node !== document.body && node !== document.documentElement) {
    if (/(auto|scroll|overlay)/.test(getComputedStyle(node).overflowY))
      return node;
    node = node.parentElement;
  }
  return window;
};

export const scrollToTop = (el) => {
  const t = findScrollParent(el);
  if (t === window) window.scrollTo({ top: 0 });
  else t.scrollTo({ top: 0 });
};
